export const COMMON_AAD = 'commonaad';
